<template>

  <div class="container-fluid">
    <div class="row">
      <h5 class="col-12">گزارش و نمودار راندمان کارگاه ها و نفرات</h5>
      <div class="input-group col-sm-6 my-2 h-100">
        <div class="input-group-prepend custom">
          <div class="input-group-text">
            <i class="icon-calendar-blank-outline"></i>
            <span>تاریخ شروع</span>
          </div>
        </div>
        <date-picker
          v-show=true
          :auto-submit="true"
          format="jYYYY-jMM-jDD"
          @input="setDateFromDatePicker"
          ref="datePicker"
        >
          <slot>
            <input
              :readonly=true
              v-model="selsestDate"
              class="form-control date-input"
              @click="toggleStartDatePicker"
            >
          </slot>
        </date-picker>

      </div>
      <div class="input-group col-sm-6 my-2 h-100">
        <div class="input-group-prepend custom">
          <div class="input-group-text">
            <i class="icon-calendar-blank-outline"></i>
            <span>تاریخ پایان</span>
          </div>
        </div>
        <date-picker
          v-show=true
          :auto-submit="true"
          format="jYYYY-jMM-jDD"
          @input="setDateFromDatePicker"
          ref="datePicker"
        >
          <slot>
            <input
              :readonly=true
              v-model="selsestEndDate"
              class="form-control date-input"
              @click="toggleEndDatePicker"
            >
          </slot>
        </date-picker>

      </div>

      <div class="col-6">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>گزارش راندمان کارگاه</span>
            </div>
          </div>
          <vs-select
            ref="selectedProgram"
            :isHeader="true"
            :data="companies"
            :selectedVal="companies.id"
            :header="{label:'companyName'}"
            :mode="'edit'"
            @dataChanged="companySelect"
            aria-placeholder="لطفا کارگاه را انتخاب کنید"
          ></vs-select>
          <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
        </div>
      </div>
      <div class="col-6">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>گزارش راندمان نفرات</span>
            </div>
          </div>
          <vs-select
            ref="selectedProgram"
            :isHeader="true"
            :data="persons"
            :selectedVal="persons.id"
            :header="{label:'name'}"
            :mode="'edit'"
            @dataChanged="personSelect"
            aria-placeholder="لطفا فرد مورد نظر را انتخاب کنید"
          ></vs-select>
          <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
        </div>
      </div>

      <div class="row my-2 text-center" v-if="nodata">
        <div class="col-12 mt-3">
          <h5>گزارشی ثبت نشده است</h5>
        </div>
      </div>

      <hr/>
      <h5 class="col-12 mt-3">گزارش راندمان
        {{this.randemanReportModel.companyName!== "" ? this.randemanReportModel.companyName : this.randemanReportModel.personName }}

      </h5>

      <div class="col-12 mt-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">تاریخ</th>
            <th scope="col" class="text-center">نام محصول</th>
            <th scope="col" class="text-center">کد برنامه</th>
            <th scope="col" class="text-center" v-if="randemanReportModel.companyId === 0">کارگاه</th>
            <th scope="col" class="text-center" v-if="randemanReportModel.personId === 0">اپراتور</th>
            <th scope="col" class="text-center">تعداد انجام شده</th>
            <th scope="col" class="text-center">تعداد قابل انجام</th>
            <th scope="col" class="text-center">ساعت کارکرد</th>
            <th scope="col" class="text-center">تعداد قابل تولید در ساعت</th>
            <th scope="col" class="text-center">راندمان</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i, index) in  progress">
            <td class="text-center">{{i.fDate}}</td>
            <td class="text-center">{{i.productName}}</td>
            <td class="text-center">{{i.programCode}}</td>
            <td class="text-center" v-if="randemanReportModel.companyId === 0">{{i.companyName}}</td>
            <td class="text-center" v-if="randemanReportModel.personId === 0">{{i.personName}}</td>
            <td class="text-center">{{i.todayDone}}</td>
            <td class="text-center">{{i.todayCount}}</td>
            <td class="text-center">{{i.todayHours}}</td>
            <td class="text-center">{{i.countPerHour}}</td>
            <td class="text-center">{{i.randeman}}</td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <!--<b-tab title="گزارش پیشرفت کار" >-->
      <!--<div class="row my-4">-->
      <!--<div class="row my-2 text-center" v-if="progress.workReportProgramProgressLists == null">-->
      <!--<div class="col-12 mt-3">-->
      <!--<h5>برنامه دستور تولید داده نشده است</h5>-->

      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-12 mt-3" v-else>-->

      <!--<table class="table table-striped">-->
      <!--<thead>-->
      <!--<tr>-->
      <!--<th scope="col" class="text-center">تاریخ</th>-->
      <!--<th scope="col" class="text-center">تعداد طبق برنامه</th>-->
      <!--<th scope="col" class="text-center">تعداد تولید شده</th>-->


      <!--</tr>-->
      <!--</thead>-->
      <!--<tbody>-->
      <!--<tr v-for="(item, index) in progress.workReportProgramProgressLists">-->
      <!--&lt;!&ndash;<th scope="row" class="text-center">{{item.id}}</th>&ndash;&gt;-->
      <!--<td class="text-center">{{item.date}}</td>-->
      <!--<td class="text-center">{{item.todayCount}}</td>-->
      <!--<td class="text-center">{{item.todayDone}}</td>-->

      <!--</tr>-->
      <!--</tbody>-->
      <!--</table>-->
      <!--</div>-->


      <!--</div>-->
      <!--</b-tab>-->
      <!--------first tab------->
      <b-tab title="نمودار پیشرفت کار" active>
        <div class="row my-4">
          <div class="col-12 mt-3">
            <div class="col-lg-12 col-sm-12 my-2">
              <div class="card shadow text-white  mb-1">
                <div class="card-body pb-0">
                  <div class="card-chart">
                    <canvas id="barchart1" width="1000" height="555"></canvas>
                  </div>
                </div>
              </div>
            </div>

            <!--<hr class="w-100 text-center"/>-->

            <!--<div class="col-lg-12 col-12 my-5">-->
            <!--<div class="card shadow text-white mb-1">-->
            <!--<div class="card-body pb-0">-->
            <!--<div class="card-chart">-->
            <!--<canvas id="area-chart" width="1600" height="400"></canvas>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->

          </div>
        </div>

      </b-tab>
    </b-tabs>

    <!-------------------------------------------------------------------------------->

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";
  import Moment from 'moment-jalali';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";

  export default {
    name: "randeman",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      VsSelect,
      Moment,
      datePicker: DatePicker,
    },
    data() {
      return {
        show: true,
        nodata: true,
        nodata2: true,
        access: {},
        product: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        reportTotalProgram: [],

        programCodes: [],
        companies: [],
        persons: [],
        progress: [],
        proggressChart: {},
        areaChart: {},
        selsestDate: null,
        selsestEndDate: null,
        randemanReportModel: {
          companyId: 0,
          personId: 0,
          start: "",
          end: "",
          companyName: "",
          personName: "",
        },
      };
    },
    beforeMount() {
      // this.getAllRawProductsQuantity();
      // Chart.defaults.global.defaultFontFamily = 'shabnam';
      this.getCompanies();
      this.getPersons();
    },
    methods: {

      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      findchildren(child) {
        for (let i of child) {
          if (i.children !== null) {
            this.companies.push(i);
            this.findchildren(i.children);
          } else {
            this.companies.push(i);
          }
        }
      },
      getCompanies() {
        this.isLoading = true;
        new BaseService('Company').getList().then((response) => {
          // console.log(response.data);
          this.nodata = false;
          if (response.data === null || response.data === "") {
            this.nodata = true;
          } else {
            let comp = response.data;
            for (let i of comp) {
              if (i.children !== null) {
                this.companies.push(i);
                this.findchildren(i.children);
              } else {
                this.companies.push(i);
              }
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      getPersons() {
        this.isLoading = true;
        new BaseService('Users').getList().then((response) => {
          // console.log(response.data);
          this.nodata = false;
          if (response.data === null || response.data === "") {
            this.nodata = true;
          } else {
            this.persons = response.data.data;
            for (let i of this.persons) {
              i.name = i.firstName + " " + i.lastName;
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      getProgram() {
        this.isLoading = true;
        new BaseService('Planning', '/GetAllProgramCode').getList().then((response) => {
          this.nodata = false;
          if (response.data === null || response.data === "") {
            this.nodata = true;
          } else {
            this.programCodes = response.data;
            if (this.programCodes.length > 0) {
              for (let i = 0; i < this.programCodes.length; i++) {
                this.programCodes[i].name = "برنامه کد " + this.programCodes[i].programCode + " کالای " + this.programCodes[i].productName + " تعداد " + this.programCodes[i].count + " باقیمانده " + (this.programCodes[i].count - this.programCodes[i].completed);
              }
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      programSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.getReportProgram(data.programId, data.productId);

      },
      companySelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.randemanReportModel.companyId = data.id;
        this.randemanReportModel.personId = 0;
        this.randemanReportModel.companyName = data.companyName;
        this.randemanReportModel.personName = "";
        this.getReportProgram();

      },
      personSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.randemanReportModel.personId = data.id;
        this.randemanReportModel.companyId = 0;
        this.randemanReportModel.personName = data.name;
        this.randemanReportModel.companyName = "";
        this.getReportProgram();

      },
      getReportProgram() {
        if (this.randemanReportModel.start === "") {
          this.$noty.error("لطفا تاریخ شروع را انتخاب کنید");
        } else if (this.randemanReportModel.end === "") {
          this.$noty.error("لطفا تاریخ پایان را انتخاب کنید");
        } else {
          new BaseService('WorksReports', "/GetRandemanReportCompany").getList(this.randemanReportModel).then((response) => {
            // console.log(response.data);
            this.progress = response.data;
            const dataName = [];
            const dataCount = [];
            const dataDone = [];
            const dataRandeman = [];
            const dataPerson = [];
            let dCount = 0;
            let dDone = 0;
            let dRandeman = 0;
            for (let i of this.progress) {
              i.fDate = Moment(i.date).format("jYYYY/jMM/jDD");
              var name =this.randemanReportModel.companyId !== 0 ? i.personName : i. companyName;
              dataName.push(i.fDate + "|"+name);
              // dCount += i.todayCount;
              // dDone += i.todayDone;
              // dRandeman += i.randeman;
              dataCount.push(i.todayCount);
              dataDone.push(i.todayDone);
              dataRandeman.push(i.randeman);
              dataPerson.push(i.companyName + i.personName);
            }

            let bar = "";
            if (dataName.length === 1) {
              bar = "bar";
            } else {
              bar = "line";
            }
            Chart.defaults.global.defaultFontFamily = 'shabnam';
            let polar = new Chart(document.getElementById("barchart1"), {

              type: bar,
              data: {
                labels: dataName,
                datasets: [
                  {
                    label: 'تعداد قابل انجام',
                    data: dataCount,
                    backgroundColor: 'rgba(255,193,7,0.71)',
                    borderColor: "rgba(255,143,0,0.71)"
                  },
                  {
                    label: 'تعداد انجام شده',
                    data: dataDone,
                    backgroundColor: 'rgba(249,60,103,0.71)',
                    borderColor: "rgba(198,40,40,0.71)"
                  },
                  {
                    label: 'راندمان',
                    data: dataRandeman,
                    backgroundColor: 'rgba(249,160,203,0.71)',
                    borderColor: "rgba(198,140,140,0.71)"
                  },


                ]
              },
              options: {
                scales: {
                  // xAxes: [{
                  //   stacked: true
                  // }],
                  yAxes: [{
                    stacked: false,
                    ticks: {
                      beginAtZero: true,
                      min: 0,
                    }
                  }]
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100]
                  }
                },
                title: {
                  display: true,
                  text: 'نمودار برنامه و گزارش کار'
                },
              }

            });


          }).catch((error) => {
            console.log(error)
          });
        }
      },
      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          this.selsestDate = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.randemanReportModel.start = sdate.format("YYYY-MM-DD");
          // this.sendPrePlanning();
        }
        if (this.dateClicked === 2) {
          this.selsestEndDate = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.randemanReportModel.end = sdate.format("YYYY-MM-DD");
          // this.sendPrePlanning();
        }

      },

    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
